import {
  BookOpenTextIcon,
  CreditCardIcon,
  GiftIcon,
  LandmarkIcon,
  LayoutDashboardIcon,
  MessageSquareIcon,
  PlugIcon,
  PlusCircleIcon,
  ReceiptIcon,
  SettingsIcon,
  SparklesIcon,
  UserIcon,
  UsersIcon,
  WalletIcon,
} from 'lucide-react'

import type { GlobalSearchResultItem } from './global-search.interface'

/**
 * Navigation items for global search - main app pages
 */
export const navigationItemList: GlobalSearchResultItem[] = [
  {
    id: 'chat',
    title: 'Chat',
    description: 'Start a new conversation',
    icon: MessageSquareIcon,
  },
  {
    id: 'agencies',
    title: 'Agencies',
    description: 'Browse and manage agencies',
    icon: SparklesIcon,
  },
  {
    id: 'prompt-templates',
    title: 'My Prompt Templates',
    description: 'Manage personal prompt templates',
    icon: BookOpenTextIcon,
  },
]

/**
 * Settings items for global search - organization settings pages
 */
export const settingsItemList: GlobalSearchResultItem[] = [
  {
    id: 'general',
    title: 'General Settings',
    description: 'Organization profile and preferences',
    icon: SettingsIcon,
  },
  {
    id: 'members',
    title: 'Members',
    description: 'Manage team members and roles',
    icon: UsersIcon,
  },
  {
    id: 'balance',
    title: 'Balance',
    description: 'View and manage account balance',
    icon: WalletIcon,
  },
  {
    id: 'payment-methods',
    title: 'Payment Methods',
    description: 'Manage payment methods',
    icon: LandmarkIcon,
  },
  {
    id: 'subscription',
    title: 'Subscription',
    description: 'Manage subscription plan',
    icon: CreditCardIcon,
  },
  {
    id: 'invoices',
    title: 'Invoices',
    description: 'View and download invoices',
    icon: ReceiptIcon,
  },
  {
    id: 'connectors',
    title: 'Connectors',
    description: 'Connect external services like Google Search Console and Analytics',
    icon: PlugIcon,
  },
]

/**
 * Billing items for global search - billing pages (split view)
 */
export const billingItemList: GlobalSearchResultItem[] = [
  {
    id: 'overview',
    title: 'Billing Overview',
    description: 'View billing summary',
    icon: LayoutDashboardIcon,
  },
  {
    id: 'plans',
    title: 'Plans',
    description: 'View and change subscription plans',
    icon: CreditCardIcon,
  },
  {
    id: 'top-up',
    title: 'Top Up',
    description: 'Add credits to your account',
    icon: PlusCircleIcon,
  },
  {
    id: 'redeem-code',
    title: 'Redeem Code',
    description: 'Redeem a promotional code',
    icon: GiftIcon,
  },
  {
    id: 'usage',
    title: 'Usage',
    description: 'View usage statistics',
    icon: ReceiptIcon,
  },
]

/**
 * Profile items for global search - personal profile pages
 */
export const profileItemList: GlobalSearchResultItem[] = [
  {
    id: 'general',
    title: 'Profile',
    description: 'Manage your personal profile',
    icon: UserIcon,
  },
]
